module.exports = __webpack_public_path__ + "static/media/category12.30acd6eb.jpg";